export const ru = {
    isNotSet: 'не задан',
    perWeek: 'в неделю'
};
